import { useEffect, useState } from "react";
import { BellRing, X } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { pushSupported, enablePush } from "@/lib/push";

const KEY = "jx_push_prompted";

export const PushPrompt = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || !pushSupported() || localStorage.getItem(KEY)) return;
    if (Notification.permission !== "default") return;
    const t = setTimeout(() => setShow(true), 2500);
    return () => clearTimeout(t);
  }, [user]);

  const close = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  const allow = async () => {
    close();
    try { await enablePush(); toast.success("Notifications enabled"); }
    catch (e) { toast.error(e.message || "Couldn't enable notifications"); }
  };

  if (!show) return null;
  return (
    <div data-testid="push-prompt" className="fixed z-50 left-3 right-3 bottom-24 lg:bottom-6 lg:left-auto lg:right-6 lg:w-96 rounded-2xl glass border border-[#00E7FF]/40 p-4 shadow-[0_0_30px_rgba(0,231,255,0.25)] animate-in fade-in slide-in-from-bottom-4">
      <button onClick={close} data-testid="push-prompt-close" className="absolute top-2 right-2 p-1.5 rounded-full hover:bg-white/10"><X size={14}/></button>
      <div className="flex gap-3">
        <div className="w-10 h-10 rounded-xl bg-[#00E7FF]/15 flex items-center justify-center shrink-0"><BellRing size={18} className="text-[#00E7FF]"/></div>
        <div>
          <div className="font-bold text-sm">Never miss a drop</div>
          <p className="text-xs text-white/60 mt-0.5">Get notified when creators you follow post a new video.</p>
          <div className="flex gap-2 mt-3">
            <button onClick={allow} data-testid="push-prompt-allow" className="jx-btn h-8 px-4 rounded-full bg-[#00E7FF] text-black text-xs font-extrabold">Turn on</button>
            <button onClick={close} data-testid="push-prompt-later" className="jx-btn h-8 px-4 rounded-full border border-white/15 text-xs font-semibold">Not now</button>
          </div>
        </div>
      </div>
    </div>
  );
};
